import httpClient from './httpClient'

const END_POINT = '/seller'

const RingTreeTargetRequestAPI = {

  /**
   * Create a new Ring Tree Target request for a specific offer registration
   * @param {string} accountId - The seller account ID
   * @param {string} registrationId - The seller offer registration ID
   * @param {RingTreeTargetRequest.CreateRingTreeTargetApiRequest} requestData - Ring Tree Target request details
   * @returns {Promise<RingTreeTargetRequest.CreateRingTreeTargetResponse>} Promise resolving to creation result
   */
  async createRequest(accountId, registrationId, requestData) {
    return await httpClient.post(`${END_POINT}/${accountId}/rtt-requests/offer-registrations/${registrationId}`, requestData)
  },

  /**
   * Get all Ring Tree Target requests for the specified account
   * @param {string} accountId - The seller account ID
   * @returns {Promise<RingTreeTargetRequest.GetAllRequestsResponse>} Promise resolving to array of requests
   */
  async getAllRequests(accountId) {
    return await httpClient.get(`${END_POINT}/${accountId}/rtt-requests`)
  },

  /**
   * Get detailed information for a specific Ring Tree Target request
   * @param {string} accountId - The seller account ID
   * @param {string} requestId - The specific request ID
   * @returns {Promise<RingTreeTargetRequest.GetRequestDetailsResponse>} Promise resolving to request details
   */
  async getRequestDetails(accountId, requestId) {
    return await httpClient.get(`${END_POINT}/${accountId}/rtt-requests/${requestId}`)
  },

  /**
   * Switch the creative of a completed Medicare RTT that RingbaX created. The request goes to
   * creativeUpdateStatus InProgress and the RTT url is rewritten in Ringba asynchronously, so the
   * list polls until the update completes or fails.
   * @param {string} accountId - The seller account ID
   * @param {string} requestId - The Ring Tree Target request ID
   * @param {string} creativeId - The approved, enabled creative to use
   * @returns {Promise<void>}
   */
  async changeCreative(accountId, requestId, creativeId) {
    return await httpClient.patch(`${END_POINT}/${accountId}/rtt-requests/${requestId}/creative`, { creativeId })
  },

  /**
   * Switch every completed RTT of the account whose creative is exactly `fromCreativeId` to
   * `toCreativeId`. Each RTT is reported started or skipped (with a reason).
   * @param {string} accountId - The seller account ID
   * @param {string} fromCreativeId - The creative value the RTTs carry today, as stored
   * @param {string} toCreativeId - The approved, enabled creative to use
   * @returns {Promise<{ data: { startedCount: number, skippedCount: number, results: Array<{ requestId: string, rttName: string, outcome: string, reason: ?string }> } }>}
   */
  async changeCreativeForAll(accountId, fromCreativeId, toCreativeId) {
    return await httpClient.post(`${END_POINT}/${accountId}/rtt-requests/change-creative`, { fromCreativeId, toCreativeId })
  }
}

export default RingTreeTargetRequestAPI